
export default function Resault({metaData}) {
  return (
    <div className={`text-end mb-3`} style={{fontSize:'14px'}}>
        {
        metaData &&
            metaData.total > 0
            ? (
                <>
                    {metaData.total}
                    <span>
                        {' '}Results
                    </span>
                </>
            ) : (
                <span>
                    No Results
                </span>
            )
        }
    </div>
  )
}
